






























































































































































































































































































import Vue from 'vue';
import {
  Exhibitor,
  exhibitor as exhibitorM,
  exhibition as exhibitionM,
  Exhibition,
  exhibitorCompany,
  ExhibitorCompany,
  brand,
  Brand,
  booth,
  Booth,
  item,
  Item,
  message,
  contact,
  ContactListItem,
  calender,
} from 'mostra';

// import exhibitorM, { Exhibitor } from '@/modules/exhibitor/exhibitor';
// import companyM, { Company } from '@/modules/exhibitor/company';
// import { calender } from '@/modules/calender';

export type ExhibitorInfo = {
  exhibitors: Exhibitor[];
  company: ExhibitorCompany;
}

export type DataType = {
  loading: boolean;
  exhibitor: ExhibitorInfo | null;
  brands: Brand[];
  booths: Booth[];
  items: Item[];
  exhibitions: Exhibition[];
  contactList: ContactListItem[];
};

export default Vue.extend({
  name: 'admin-admin-exhibitor-detail',
  data(): DataType {
    return {
      loading: true,
      exhibitor: null,
      brands: [],
      booths: [],
      items: [],
      exhibitions: [],
      contactList: [],
    };
  },
  async mounted() {
    this.$loading(true);
    this.loading = true;
    try {
      await this.fetchData();
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.loading = false;
      this.$loading(false);
    }
  },
  methods: {
    latestMessage(messages: any[]) {
      const m = messages[messages.length - 1];
      return m || { id: null, data: {} };
    },
    typeStr(t: number) {
      return message.typeOfString(t);
    },
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async fetchData() {
      const cid = this.$route.params.id;
      const es = await exhibitorM.loadsByCID(cid);
      const cp = await exhibitorCompany.load(cid);
      if (!cp) throw Error('Can not find company of exhibitor');
      this.exhibitor = {
        exhibitors: es,
        company: cp,
      };
      this.brands = await brand.loadsByOwner(cid);
      this.booths = await booth.loadsByOwner(cid);
      this.items = await item.loadsByOwner(cid);
      this.exhibitions = await exhibitionM.loadsByOwner(cid);
      this.contactList = await contact.loadContactListByExhibitor(cid, true);
    },
    async onClickUpdateCompany() {
      this.$loading(true);
      try {
        if (!this.exhibitor || !this.exhibitor.company) throw new Error('exhibitor is null');
        const uid = this.$auth.uid;
        this.exhibitor.company = await exhibitorCompany.save(uid, this.exhibitor.company);
        this.$success('保存しました');
      } catch (error: any) {
        this.$error('保存に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
  },
});
